// ** MUI Imports
import Card from '@mui/material/Card'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import Typography from '@mui/material/Typography'
import TableContainer from '@mui/material/TableContainer'
import { Avatar, Button, CardHeader, Menu, MenuItem, Pagination } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { chgUserManager, chgUserRetailer, chgUserUser, chgUserWholesaler, getAllCustomers } from '../../../State/Auth/Action'
import { useDispatch, useSelector } from "react-redux";



const Customers = () => {
  const navigate=useNavigate();
  const dispatch = useDispatch();
  const {auth}=useSelector(store=>store)
  const [anchorElArray, setAnchorElArray] = useState([]);
  const [orderStatus, setOrderStatus] = useState("");
  
  useEffect(()=>{
    //console.log("customer table use effect")
    const data={
      emailId:localStorage.getItem("emailid"),
      reqJWT:auth?.jwt?.access_token
    }
    dispatch(getAllCustomers(data))
  },[])
  //console.log("customer table ")

  const handleUpdateStatusMenuClick = (event, index) => {
    const newAnchorElArray = [...anchorElArray];
    newAnchorElArray[index] = event.currentTarget;
    setAnchorElArray(newAnchorElArray);
  };

  const handleUpdateStatusMenuClose = (index) => {
    const newAnchorElArray = [...anchorElArray];
    newAnchorElArray[index] = null;
    setAnchorElArray(newAnchorElArray);
  };

  const handleManager = (userId, index) => {
    handleUpdateStatusMenuClose(index);
    const reqData={
      userId:userId,
      reqJWT:auth?.jwt?.access_token
    }
    dispatch(chgUserManager(reqData));
    setOrderStatus("MANAGER")
  };

  const handleWholesaler = (userId,index) => {
    handleUpdateStatusMenuClose(index);
    const reqData={
      userId:userId,
      reqJWT:auth?.jwt?.access_token
    }
    dispatch(chgUserWholesaler(reqData));
    setOrderStatus("WHOLESALER")
  };

  const handleRetailer = (userId,index) => {
    handleUpdateStatusMenuClose(index);
    const reqData={
      userId:userId,
      reqJWT:auth?.jwt?.access_token
    }
    dispatch(chgUserRetailer(reqData));
    setOrderStatus("RETAILER")
  };

  const handleUser= (userId,index) => {
    handleUpdateStatusMenuClose(index);
    const reqData={
      userId:userId,
      reqJWT:auth?.jwt?.access_token
    }
    dispatch(chgUserUser(reqData));
    setOrderStatus("USER")
  };

  return (
    <Card>
      <CardHeader
          title='New Customers'
          sx={{ pt: 2, alignItems: 'center', '& .MuiCardHeader-action': { mt: 0.6 } }}
          action={<Typography onClick={()=>navigate("/admin/customers")} variant='caption' sx={{color:"blue",cursor:"pointer",paddingRight:".8rem"}}>View All</Typography>}
          titleTypographyProps={{
            variant: 'h5',
            sx: { lineHeight: '1.6 !important', letterSpacing: '0.15px !important' }
          }}
        />
      {(auth?.user?.firstname && (auth?.user?.role==='ADMIN' || auth?.user?.role==='MANAGER' || auth?.user?.role==='WHOLESALER' || auth?.user?.role==='RETAILER')) ? (
      <TableContainer>
        <Table sx={{ minWidth: 390 }} aria-label='table in dashboard'>
          <TableHead>
            <TableRow>
            <TableCell sx={{ textAlign: "center" }}>Image</TableCell>
              <TableCell sx={{ textAlign: "center" }}>Name</TableCell>
              <TableCell sx={{ textAlign: "center" }}>Email</TableCell>
              <TableCell sx={{textAlign: "center"}}>Role</TableCell>
              <TableCell sx={{ textAlign: "center" }}>Change Role</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {auth?.customers?.map((item,index) => 
              <TableRow hover key={item.firstname} sx={{ '&:last-of-type td, &:last-of-type th': { border: 0 } }}>
                <TableCell> <Avatar >{item.firstname[0].toUpperCase()}</Avatar> </TableCell>
                <TableCell>{item.firstname} {item.lastname}</TableCell>
                <TableCell>{item.emailid}</TableCell>
                <TableCell>{item.role}</TableCell>
                <TableCell
                    sx={{ textAlign: "center" }}
                    className="text-white"
                  >
                    {/* <Button>{item.orderStatus==="PENDING"?"PENDING": item.orderStatus==="PLACED"?"CONFIRMED":item.orderStatus==="CONFIRMED"?"SHIPPED":"DELEVERED"}</Button> */}
                    <div>
                      <Button
                        id={`basic-button-${item.id}`}
                        aria-controls={`basic-menu-${item.id}`}
                        aria-haspopup="true"
                        aria-expanded={Boolean(anchorElArray[index])}
                        onClick={(event) =>
                          handleUpdateStatusMenuClick(event, index)
                        }
                      >
                        Status
                      </Button>
                      <Menu
                        id={`basic-menu-${item.id}`}
                        anchorEl={anchorElArray[index]}
                        open={Boolean(anchorElArray[index])}
                        onClose={() => handleUpdateStatusMenuClose(index)}
                        MenuListProps={{
                          "aria-labelledby": `basic-button-${item.id}`,
                        }}
                      >
                        <MenuItem
                          onClick={() => handleManager(item.id, index)}
                          disabled={item.role==="MANAGER"}
                        >
                          MANAGER
                        </MenuItem>
                        <MenuItem
                          onClick={() => handleWholesaler(item.id, index)}
                          disabled={item.role==="WHOLESALER"}
                        >
                          WHOLESALER
                        </MenuItem>
                        <MenuItem 
                          onClick={() => handleRetailer(item.id, index)}
                          disabled={item.role==="RETAILER"}
                        >
                          RETAILER
                        </MenuItem>
                        <MenuItem 
                          onClick={() => handleUser(item.id, index)}
                          disabled={item.role==="USER"}
                        >
                          USER
                        </MenuItem>
                      </Menu>
                    </div>
                  </TableCell>       
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      ):(<div></div>)}
    </Card>
  )
}

export default Customers
